<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h1 mat-dialog-title>Manage Tag Categories</h1>

<mat-dialog-content class="mat-typography">
	<div style="min-width: 600px;">
		@if (loading) {
			<div class="text-center p-3">
				<i class="pi pi-spin pi-spinner" style="font-size: 2em;"></i>
			</div>
		}

		@if (!loading && categories.length === 0) {
			<p>No categories found.</p>
		}

		@if (!loading && categories.length > 0) {
			<p-table [value]="categories" [paginator]="false" [responsive]="true" styleClass="p-datatable-sm">
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 40%;">Category</th>
						<th style="width: 15%;">Tag Count</th>
						<th style="width: 15%;">Color</th>
						<th style="width: 30%;">Actions</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-cat>
					<tr>
						<td>
							@if (!isEditing(cat)) {
								<span>{{ cat.name }}</span>
							}
							@if (isEditing(cat)) {
								<input pInputText type="text" [(ngModel)]="editedValue"
									   style="width: 100%;" maxlength="50"
									   (keyup.enter)="saveRename(cat)"
									   (keyup.escape)="cancelEdit()" />
							}
						</td>
						<td>{{ cat.count }}</td>
						<!-- R4 — color picker -->
						<td>
							<div style="display:flex; align-items:center; gap:6px;">
								<input type="color"
									   [value]="cat.color || '#cccccc'"
									   (input)="onColorChange(cat, $any($event.target).value)"
									   style="width:36px; height:28px; border:1px solid #ccc; border-radius:4px; padding:0; cursor:pointer;"
									   pTooltip="Pick a color — applies to all tags in this category"
									   tooltipPosition="top" />
								@if (cat.color) {
									<button pButton pRipple type="button" icon="pi pi-times"
											class="p-button-text p-button-sm p-button-rounded"
											pTooltip="Clear color"
											tooltipPosition="top"
											(click)="clearColor(cat)">
									</button>
								}
							</div>
						</td>
						<td>
							@if (!isEditing(cat)) {
								<button pButton pRipple type="button" icon="pi pi-pencil"
										class="p-button-text p-button-sm"
										pTooltip="Rename" tooltipPosition="top"
										(click)="startEdit(cat)">
								</button>
								<button pButton pRipple type="button" icon="pi pi-times-circle"
										class="p-button-text p-button-sm p-button-danger"
										pTooltip="Clear category from tags"
										tooltipPosition="top"
										(click)="onClear(cat)">
								</button>
							}
							@if (isEditing(cat)) {
								<button pButton pRipple type="button" icon="pi pi-check"
										class="p-button-text p-button-sm p-button-success"
										pTooltip="Save" tooltipPosition="top"
										(click)="saveRename(cat)">
								</button>
								<button pButton pRipple type="button" icon="pi pi-times"
										class="p-button-text p-button-sm"
										pTooltip="Cancel" tooltipPosition="top"
										(click)="cancelEdit()">
								</button>
							}
						</td>
					</tr>
				</ng-template>
			</p-table>
		}
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
